<div class="user-terms-conditions-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>POLIZZA COLLETTIVA</h2>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="spinner-container">
        <div class=WordSection1>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText align=center style='text-align:center'><span lang=IT style='font-size:14.0pt;
            '>RAMO TRASPORTI</span></p>

            <p class=MsoBodyText align=center style='text-align:center'><span lang=IT style='font-size:10.0pt'>MARINE
                    DEPARTMENT</span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText align=center style='text-align:center'><b><span lang=IT style='font-size:18.0pt;
            '>POLIZZA COLLETTIVA</span></b></p>

            <p class=MsoBodyText align=center style='text-align:center'><b><span lang=IT style='font-size:18.0pt;
            '>N. MA00001795</span></b><span lang=IT style='font-size:18.0pt;'></span></p>

            <p class=MsoBodyText><span lang=IT><span>   </span><span>                            
                    </span><span>    </span><b><span>       </span></b></span></p>

            <p class=MsoBodyText><b><span lang=IT></span></b></p>

            <p class=MsoBodyText><b><span lang=IT></span></b></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText align=center style='text-align:center'><b><span lang=IT style='font-size:14.0pt;
            '>AIG EUROPE S.A.</span></b></p>

            <p class=MsoBodyText align=center style='text-align:center'><span lang=IT style='font-size:11.0pt;'>alle
                    Condizioni Generali
                    allegate ed alle Condizioni Particolari che seguono, </span></p>

            <p class=MsoBodyText align=center style='text-align:center'><span lang=IT style='font-size:11.0pt;'>assicura
                    tutte le merci
                    spedite o trasportate che si intenderanno garantite in base ai termini e con le
                    modalità qui previste.</span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText align=center style='text-align:center'><span lang=DE>CONTRAENTE:</span></p>

            <p class=MsoBodyText align=center style=' text-align:center'><i><span lang=DE></span></i></p>

            <p class=MsoBodyText align=center style=' text-align:center'><span lang=DE>UPS
                    Capital Verischerungsvermittlung GmbH, Sede
                    Italiana</span></p>

            <p class=MsoBodyText align=center style=' text-align:center'><span lang=IT>Via
                                    Gaudenzio Fazioli n. 15/8, Milano (MI)</span></p>

            <p class=MsoBodyText align=center style='text-align:center'><span lang=IT>Codice
                    fiscale 09991560963</span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText align=center style='text-align:center'><b><u><span lang=IT style='font-size:11.0pt;
            '>IMPORTANTE</span></u></b></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText align=center style='text-align:center'><span lang=IT>LEGGETE
                    ATTENTAMENTE LA VOSTRA POLIZZA</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT>Eventuali testi di Clausole
                    riportate per titoli nelle Condizioni Particolari e riconosciute dal Mercato
                    Nazionale e/o Internazionale si considerano come integralmente trascritte e
                    pertanto accettate.<span>  </span></span></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT>In caso di sinistro l’Assicurato,
                    come in seguito indicato, è invitato a rivolgersi al più vicino Commissario
                    d’Avaria nominato dalla Compagnia.</span></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT>l'Assicurato non deve consentire
                    esonero o limitazione della responsabilità del Vettore oltre quanto disposto
                    dalla legge o dalle Convenzioni Internazionali. </span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <b><span lang=IT style='font-size:12.0pt;
            font-family:"Arial",sans-serif;color:black;
            '><br clear=all style='
            page-break-before:always'>
                </span></b>

            <p class=MsoBodyText align=center style='margin-right:-.35pt;text-align:center;
            line-height:12.0pt;'><b><span lang=IT style='font-size:12.0pt;'></span></b></p>

            <p class=MsoBodyText align=center style='margin-right:-.35pt;text-align:center;
            line-height:12.0pt;'><b><span lang=IT style='font-size:12.0pt;'>DEFINIZIONI</span></b></p>

            <p class=MsoBodyText style='margin-right:-.35pt;line-height:12.0pt;'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='margin-right:-.35pt;line-height:12.0pt;'><b><span lang=IT
                        style='font-size:8.0pt;'>Ai sotto elencati termini, le
                        Parti attribuiscono il seguente significato:</span></b></p>

            <p class=MsoBodyText style='margin-top:0in;margin-right:-.35pt;margin-bottom:
            0in;margin-left:1.25in;margin-bottom:.0001pt;text-align:justify;text-indent:
            -1.25in;line-height:12.0pt;'><i><span lang=IT style='font-size:8.0pt;'>Contraente</span></i><b><span
                        lang=IT style='font-size:8.0pt;
            '><span>                      </span></span></b><span lang=IT style='font-size:8.0pt;'>UPS Capital
                    Versicherungsvermittlung GmbH, Sede Italiana nell’ambito della propria attività
                    di intermediario assicurativo o spedizioniere svolta in Italia</span></p>

            <p class=MsoBodyText style='margin-top:0in;margin-right:-.35pt;margin-bottom:
            0in;margin-left:1.25in;margin-bottom:.0001pt;text-align:justify;text-indent:
            -1.25in;line-height:12.0pt;'><i><span lang=IT style='font-size:8.0pt;
            '>Assicurato</span></i><b><span lang=IT style='font-size:8.0pt;'><span>                      
                        </span></span></b><span lang=IT style='font-size:8.0pt;'>il proprietario dei, nonché
                    <span> </span>titolare dell’interesse ad assicurare i, beni per
                    il quale il Contraente, in qualità di intermediario assicurativo propone la
                    copertura assicurativa, e/o per il quale il Contraente, in qualità di
                    spedizioniere, concluda contratti di trasporto, nella misura in cui tale
                    soggetto (o altri per suo conto) richieda al Contraente di assicurare tali beni
                    sulla base della presente polizza e sottoscriva l’apposito modulo di adesione
                    alla copertura predisposto dal Contraente, purché quest’ultimo acconsenta e abbia
                    confermato e/o accetti di includere in copertura i detti beni. Il termine
                    Assicurato includerà, laddove rilevante ai sensi di Polizza, anche ogni altro
                    soggetto che sopporti il rischio della perdita e/o dei danni a tali beni
                    assicurati.</span></p>

            <p class=MsoBodyText style='margin-right:-.35pt;text-align:justify;line-height:
            12.0pt;'><i><span lang=IT style='font-size:8.0pt;'>Compagnia</span></i><span lang=IT
                    style='font-size:8.0pt;'><span>                      </span>l’impresa assicuratrice e
                    le eventuali coassicuratrici</span></p>

            <p class=MsoBodyText style='margin-right:-.35pt;text-align:justify;line-height:
            12.0pt;'><i><span lang=IT style='font-size:8.0pt;'>Assicurazione</span></i><b><span lang=IT style='font-size:8.0pt;
            '><span>                 </span></span></b><span lang=IT style='font-size:8.0pt;'>il contratto di
                    assicurazione<a name="OLE_LINK1"><b></b></a></span></p>

            <p class=MsoBodyText style='margin-right:-.35pt;text-align:justify;line-height:
            12.0pt;'><span><i><span lang=IT style='font-size:8.0pt;
            '>Polizza</span></i></span><span><b><span lang=IT
                            style='font-size:8.0pt;'><span>                            
                            </span></span></b></span><span><span lang=IT>il documento che prova
                        l’assicurazione<b></b></span></span></p>

            <span></span>

            <p class=MsoBodyText style='margin-right:-.35pt;text-align:justify;line-height:
            12.0pt;'><i><span lang=IT style='font-size:8.0pt;'>Rischio</span></i><b><span lang=IT style='font-size:8.0pt;
            '><span>                            </span></span></b><span lang=IT style='font-size:8.0pt;'>la probabilità
                    che si
                    verifichi il sinistro<b></b></span></p>

            <p class=MsoBodyText style='margin-top:0in;margin-right:-.35pt;margin-bottom:
            0in;margin-left:148.5pt;margin-bottom:.0001pt;text-align:justify;text-indent:
            -148.5pt;line-height:12.0pt;'><i><span lang=IT style='font-size:8.0pt;
            '>Franchigia</span></i><span lang=IT style='font-size:
            8.0pt;'> <span>                      </span>l’importo,
                    in cifra fissa od in percentuale del valore assicurato, da dedurre
                    dall’indennizzo (ove applicabile)<i></i></span></p>

            <p class=MsoBodyText style='margin-right:-.35pt;text-align:justify;line-height:
            12.0pt;'><i><span lang=IT style='font-size:8.0pt;'>Indennizzo</span></i><span lang=IT
                    style='font-size:8.0pt;'><span>                       </span>la somma dovuta dalla
                    Compagnia in caso di sinistro</span></p>

            <p class=MsoBodyText style='margin-top:0in;margin-right:-.35pt;margin-bottom:
            0in;margin-left:92.15pt;margin-bottom:.0001pt;text-align:justify;text-indent:
            -92.15pt;line-height:12.0pt;'><i><span lang=IT style='font-size:8.0pt;
            '>Premio</span></i><b><span lang=IT style='font-size:8.0pt;'><span>                         
                        </span><span>   </span></span></b><span lang=IT style='font-size:
            8.0pt;'>la somma dovuta alla Compagnia per
                    l’assicurazione del risc</span><span lang=IT style='font-size:8.0pt'>hio come
                    indicato di volta in volta nell’ultima versione del <i>Rate-sheet </i>che il singolo assicurato
                    abbia sottoscritto</span></p>

            <p class=MsoBodyText style='margin-top:0in;margin-right:-.35pt;margin-bottom:
            0in;margin-left:92.15pt;margin-bottom:.0001pt;text-align:justify;text-indent:
            -92.15pt;line-height:12.0pt;'><i><span lang=IT style='font-size:8.0pt'>Vettori
                        designati<span>              </span></span></i><span lang=IT style='font-size:8.0pt'>i vettori
                    di piccole spedizioni di volta in
                    volta preventivamente approvati dalla Contraente</span><b><span lang=IT></span></b></p>

            <p class=MsoBodyText><b><span lang=IT style='font-size:12.0pt;'></span></b></p>

            <p class=MsoBodyText align=center style='text-align:center'><b><span lang=IT style='font-size:12.0pt;
            '>CONDIZIONI PARTICOLARI</span></b></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Le seguenti
                    Condizioni Particolari prevalgono in caso di discordanza sulle Condizioni
                    Generali dei capitolati di polizza dell’allegata Polizza Italiana Merci
                    Trasportate (ed. 99) nonché sulle Clausole a stampa allegate alla pre­sente.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La garanzia è
                    prestata in base alle dichiarazioni dell’Assicurato, il quale è tenuto a
                    manifestare tutte le circostanze che possano influire sulla valutazione del
                    rischio.</span></p>

            <p class=MsoBodyText><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art.<span>  </span>1<span>       
                        </span>OGGETTO
                        DELL’ASSICURAZIONE</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La presente
                    Assicurazione copre la perdita e/o i danni ai beni indicati nell’articolo
                    successivo, a condizione che <i>(i) </i>della
                    spedizione di tali beni sia stata data notizia al Contraente, il quale deve
                    aver confermato/accettato di inserire tali beni nell’ambito della presente
                    copertura, come previsto dall’ultimo paragrafo del presente articolo e <i>(ii) </i>tali beni siano
                    spediti o trasportati da e/o per conto dell’Assicurato.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Si intendono
                    incluse nella presente assicurazione esclusivamente le merci movimentate da un
                    Vettore designato relativamente a:<span>   </span></span></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT style='font-family:Wingdings;
            '><span>§<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                        </span></span></span><span lang=IT>acquisti ove i termini di resa pongano il rischio del
                    trasporto a
                    carico dell’Assicurato;</span></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT style='font-family:Wingdings;
            '><span>§<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                        </span></span></span><span lang=IT>vendite;</span></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT style='font-family:Wingdings;
            '><span>§<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                        </span></span></span><span lang=IT>resi;</span></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT style='font-family:Wingdings;
            '><span>§<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                        </span></span></span><span lang=IT>invii per la lavorazione presso terzi, compreso il viaggio di
                    ritorno e
                    le movimentazioni fra gli stessi;</span></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT style='font-family:Wingdings;
            '><span>§<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                        </span></span></span><span lang=IT>trasferimenti inter-company fra società controllate,
                    collegate e
                    simili.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>Limitatamente alle merci rese dal
                        destinatario o dallo
                        stesso non ritirate o comunque per quelle di ritorno al magazzino d’origine, la
                        garanzia resterà operante a condizione che le stesse risultino confezionate
                        negli imballi originali ed il vettore non abbia sollevato eccezioni sul loro
                        stato.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Ogni spedizione
                    di beni per cui sia richiesta la copertura assicurativa deve essere previamente
                    comunicata dall’Assicurato al Contraente affinché la stessa sia inclusa nella
                    copertura fornita dalla presente Polizza. Tale spedizione di beni si considera
                    assicurata se e nella misura in cui il Contraente confermi/accetti la copertura
                    della stessa.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Il Contraente
                    avrà sempre diritto di rifiutare di includere nella presente copertura qualunque
                    spedizione. La conferma/accettazione di ogni singola spedizione di beni è a
                    discrezione del Contraente e, pertanto, né il Contraente né l’Assicuratore
                    hanno alcun obbligo di accettare/confermare la copertura assicurativa.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Ciascuna
                    spedizione di beni deve essere ritirata dal o consegnata al Vettore designato entro
                    48 ore dal momento in cui la spedizione sia stata comunicata al e
                    confermata/accettata dal Contraente.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='
            page-break-after:avoid;'><b><span lang=IT>Art. 2<span>        
                        </span>MERCI ASSICURATE</span></b></p>

            <p class=MsoBodyText style='text-align:justify;
            page-break-after:avoid'><b><span lang=IT>La
                        presente Polizza assicura esclusivamente (e secondo quanto previsto dall’art.
                        1, nonché dalle condizioni della presente Polizza) le merci trasportate da un
                        Vettore designato e approvate per iscritto di volta in volta dal Contraente,
                        tramite il <i>Rate Sheet</i> prima che abbia inizio la singola spedizione.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <h4><span lang=IT style='font-size:9.0pt;;font-family:"Arial",sans-serif;
            '>Art. 3<span>         </span>ESCLUSIONI
                    MERCEOLOGICHE</span></h4>

            <p class=MsoNormal style='text-align:justify'><span lang=IT style='font-size:
            9.0pt;;font-family:"Arial",sans-serif;'>Sono escluse dall’Assicurazione, salvo esplicito accordo fra
                    le parti prima dell’inizio del trasporto, le spedizioni ed i trasporti di:</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif;'>oggetti
                    aventi valore d’arte o di affezione,</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif;'>piante
                    ed animali vivi, merci deperibili o da trasportarsi a temperatura controllata,</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT
                    style='font-size:9.0pt;;font-family:"Arial",sans-serif;'>autoveicoli
                    e motoveicoli,</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif;'>esplosivi,
                </span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif;'>tabacchi,
                </span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT style='font-size:9.0pt;font-family:"Arial",sans-serif;'>pelli
                    e pellicce,</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif;'>masserizie,</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif;'>qualsiasi
                    altra merce che non sia espressamente menzionata dall’art. 2.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 4<span>         </span>MERCI
                        USATE</span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>Relativamente ai trasporti di merce usata,
                    dalla garanzia si intendono
                    esclusi tutti i danni preesistenti o comunque non specificatamente attribuibili
                    ad un avvenimento di trasporto avvenuto durante l’operatività della presente Polizza,
                    nonché i danni da abrasione, ammaccatura, ruggine, ossidazione, alterazione
                    meccanica/elettronica o di natura estetica o che comunque riguardano la
                    superficie del bene, ma che non compromettano la funzionalità dello stesso. </span><span
                    lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 5<span>         </span>VALIDITA’
                        TERRITORIALE</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La Polizza è
                    valida per le spedizioni ed i trasporti effettuati nell’ambito del Mondo
                    intero.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>Salvo esplicito accordo fra le parti prima
                        dell’inizio
                        del trasporto, a tassi e condizioni da convenirsi, dalla garanzia si intendono
                        escluse le spedizioni destinate, provenienti od in transito in</span></b></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><b><span lang=IT>Repubblica autonoma di Crimea, Libia, Iraq, Afghanistan,
                        Eritrea,
                        Somalia;</span></b></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=ES><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><b><span lang=ES>Iran, Siria, Sudan, Myanmar,
                        Cuba e Nord
                        Corea;</span></b></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><b><span lang=IT>Paesi aventi disposizioni di legge che impongano la
                        copertura con compagnie
                        di assicurazione locali;</span></b></p>

            <p class=MsoBodyText style='margin-left:19.85pt;text-align:justify;text-indent:
            -19.85pt;'><span lang=IT><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><b><span lang=IT>“Location” che al momento dell’inizio del trasporto
                        risultino con
                        livello di rischio classificato come “Very high” sul sito internet </span></b><span lang=IT><a
                        href="http://watch.exclusive-analysis.com/jccwatchlist.html"><b>http://watch.exclusive-analysis.com/jccwatchlist.html</b></a><b>
                        gestito dall’organizzazione Exclusive
                        Analysis.</b></span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT></span></b></p>

            <p class=MsoNormal style='text-align:justify'><b><span lang=IT
                        style='font-size:9.0pt;font-family:"Arial",sans-serif'>Art.
                        6<span>      </span>INOPERATIVITA’ DELLA COPERTURA A
                        SEGUITO DI SANZIONI</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>La Compagnia non è tenuta a fornire
                        copertura e a
                        indennizzare alcuna richiesta di risarcimento o a pagare alcunché in virtù del
                        presente contratto qualora essa o il Contraente, la loro capogruppo o le loro
                        controllanti, o un loro agente, o un’agente della loro capogruppo o delle loro controllanti,
                        nel far ciò, incorrano nel pagamento di qualsivoglia sanzione, proibizione o
                        restrizione prevista da risoluzioni delle Nazioni Unite o sanzioni economiche o
                        commerciali, ai sensi delle leggi o dei regolamenti dell'Unione Europea o degli
                        Stati Uniti d'America.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 7<span>     </span>CONDIZIONI DI
                        ASSICURAZIONE</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La presente
                    copertura è prestata in base alle Condizioni Generali dell’allegata Polizza di
                    Assicurazione Merci Trasportate (ed. 99), nella misura in cui non confliggono o
                    non sono derogate dalle presenti Condizioni Speciali, integrate agli effetti
                    della delimitazione e della durata della copertura e ferma restando
                    l'applicazione della Legge Italiana, dalle seguenti allegate clausole:</span></p>

            <p class=MsoBodyText style='margin-left:0in;text-indent:0in;
            '><span lang=IT style='font-family:
            "Times New Roman",serif'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=ES-AR>Institute
                    Cargo Clauses (A) ed. 1. </span><span lang=IT>1. 1982</span></p>

            <p class=MsoBodyText style='margin-left:0in;text-indent:0in;
            '><span lang=EN style='font-family:
            "Times New Roman",serif;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=EN>Institute
                    Cargo Clauses (Air) ed 1.1.</span><span lang=EN>
                </span><span lang=IT>1982</span><span lang=EN></span></p>

            <p class=MsoBodyText style='margin-left:0in;text-indent:0in;
            '><span style='font-family:"Times New Roman",serif;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=EN>Institute
                    Strikes Clauses (Cargo) ed. 1. </span><span>1. 1982</span></p>

            <p class=MsoBodyText style='margin-left:0in;text-indent:0in;
            '><span style='font-family:"Times New Roman",serif;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span>Institute
                    Strikes Clauses (Air Cargo) ed. 1.1.1982</span></p>

            <p class=MsoBodyText style='margin-left:0in;text-indent:0in;
            '><span style='font-family:"Times New Roman",serif;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=EN-GB>Institute
                    War Clauses (Cargo) ed. 1. </span><span>1. 1982</span></p>

            <p class=MsoBodyText style='margin-left:0in;text-indent:0in;
            '><span lang=EN-GB style='font-family:
            "Times New Roman",serif;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=EN-GB>Institute
                    War Clauses (Air Cargo) ed. 1.1.</span><span>
                    1982</span><span lang=EN-GB></span></p>

            <p class=MsoBodyText style='margin-left:0in;text-indent:0in;
            '><span lang=IT style='font-family:
            "Times New Roman",serif'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=IT>Cargo ISM Endorsement. ed.
                    1.5.1998</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=EN-GB style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=EN-GB style='font-size:9.0pt;
            ;font-family:"Arial",sans-serif;'>Termination of Transit Clause
                    (Terrorism) ed. 1.1.2002</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span style='font-size:9.0pt;font-family:"Arial",sans-serif;'>Institute
                    Radioactive Contamination, Chemical,
                    Biological, Biochemical and Electromagnetic Weapons Exclusion Clause ed.
                    10.11.2003</span></p>

            <p class=MsoNormal style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=FR style='font-size:9.0pt;'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><span lang=FR style='font-size:9.0pt;font-family:"Arial",sans-serif;
            '>Istitute Cyber Attack Exclusion Clause ed. 10.11.2003<span>  </span></span></p>

            <p class=MsoNormal style='text-align:justify'><span lang=FR style='font-size:
            9.0pt;;font-family:"Arial",sans-serif;'></span></p>

            <table class=MsoTableGrid border=1 cellspacing=0 cellpadding=0
                style='background:#A6A6A6;border-collapse:collapse;border:none;'>
                <tr>
                    <td width=623 valign=top style='width:467.35pt;border:solid windowtext 1.0pt;
              padding:0in 5.4pt 0in 5.4pt'>
                        <p class=MsoNormal style='text-align:justify'><b><span lang=IT style='font-size:9.0pt;;
              font-family:"Arial",sans-serif;
              color:black;'>AVVERTENZA&gt;&gt;</span></b><span lang=IT style='font-size:9.0pt;;font-family:"Arial",sans-serif;
              color:black;'>
                                La presente Assicurazione è soggetta: </span><span lang=IT style='font-size:
              9.0pt;;font-family:"Arial",sans-serif;'></span></p>
                        <p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
              '><span lang=IT style='font-size:9.0pt;font-family:Symbol;'><span>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span></span><span lang=IT style='font-size:9.0pt;
              font-family:"Arial",sans-serif;color:black;;'>ai limiti
                                temporali della copertura previsti dall’Art. 13; </span><span lang=IT style='font-size:9.0pt;font-family:"Arial",sans-serif;
              '></span></p>
                        <p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
              '><span lang=IT style='font-size:9.0pt;font-family:Symbol;'><span>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span></span><span lang=IT style='font-size:9.0pt;
              font-family:"Arial",sans-serif;color:black;'>a
                                specifici limiti in merito alle modalità e i requisiti delle spedizioni previsti
                                dall’Art. 14; </span><span lang=IT style='font-size:9.0pt;font-family:"Arial",sans-serif;
              '></span></p>
                        <p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
              '><span lang=IT style='font-size:9.0pt;font-family:Symbol;'><span>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span></span><span lang=IT style='font-size:9.0pt;
              font-family:"Arial",sans-serif;color:black;;'>alle specifiche
                                esclusioni di cui all’Art. 16; e</span><span lang=IT style='font-size:9.0pt;
              font-family:"Arial",sans-serif;'></span></p>
                        <p class=MsoListParagraph style='text-align:justify;text-indent:-.25in;
              '><span lang=IT style='font-size:9.0pt;font-family:Symbol;'><span>·<span
                                        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span></span></span><span lang=IT style='font-size:9.0pt;
              font-family:"Arial",sans-serif;color:black;;'>al termine
                                per la denuncia del sinistro di cui all’art. 17.</span><span lang=IT style='font-size:9.0pt;font-family:"Arial",sans-serif;
              '></span></p>
                    </td>
                </tr>
            </table>

            <p class=MsoNormal style='text-align:justify'><span lang=IT style='font-size:
            9.0pt;;font-family:"Arial",sans-serif;'></span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoHeading7 align=left style='margin-bottom:0in;text-align:left;
            '><span lang=IT style='font-size:9.0pt;'>Art. 8<span>         </span>MEZZI DI TRASPORTO
                    E MASSIMALI</span></p>

            <p class=MsoNormal style='text-align:justify'><span lang=IT style='font-size:
            9.0pt;;font-family:"Arial",sans-serif;'>La presente garanzia assicurativa è operante per le spedizioni
                    e i trasporti di beni rientranti nella presente Assicurazione effettuate con i
                    mezzi o in occasione degli avvenimenti sotto indicati. </span><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif'>Fatto salvo l’eventuale
                    minor massimale indicato nell’ultima versione del <i>Rate Sheet</i> applicabile al singolo
                    Assicurato, l’importo massimo
                    risarcibile ai sensi di Polizza è pari a € 250.000 per ogni spedizione o, se
                    minore, è pari all’effettivo valore del bene assicurato o, ancora, al minor
                    importo dichiarato dall’Assicurato ai fini di questa Assicurazione. È previsto,
                    in ogni caso, un massimale aggregato di € 5.000.000 per trasporto ovvero comunque
                    per </span><span lang=IT style='font-size:9.0pt;;
            font-family:"Arial",sans-serif;'>evento.</span></p>

            <p class=MsoNormal style='text-align:justify'><span lang=IT style='font-size:
            9.0pt;;font-family:"Arial",sans-serif;'></span></p>

            <p class=MsoNormal style='text-align:justify'><span lang=IT style='font-size:
            9.0pt;;font-family:"Arial",sans-serif;'>In caso di valore del bene superiore ai suddetti limiti,
                    fermi restando i massimali sopra indicati, in deroga a quanto previsto dalle
                    Condizioni Generali l’assicurazione è prestata “a primo rischio assoluto” senza
                    applicazione della riduzione proporzionale dell’indennizzo prevista dall’art.
                    1907 c.c.</span></p>

            <p class=MsoBodyText style='text-align:justify'><i><span lang=IT></span></i></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 9<span>        
                        </span>FRANCHIGIA</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Eventuali perdite
                    o danni risarcibili ai sensi della presente polizza saranno liquidati previa
                    deduzione della Franchigia, per ogni e qualsiasi evento, pari a 0%
                    sull’ammontare risarcibile e con un minimo di € 0.</span></p>

            <p class=MsoBodyText style='text-align:justify'><i><span lang=IT></span></i></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 10<span>      </span>VALORE
                        RISARCIBILE</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>A parziale deroga
                    di quanto previsto dall’art. 6 delle Condizioni Generali, il valore risarcibile
                    sarà determinato in base ai seguenti elementi:</span></p>

            <p class=MsoBodyText style='text-align:justify'><i><u><span lang=IT>per le merci acquistate</span></u></i>
            </p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>valore di fattura
                    di acquisto, maggiorato delle spese di trasporto, assicurazione ed altri
                    eventuali costi inerenti se documentabili (se dovuti e non già inclusi nella
                    fattura stessa).</span></p>

            <p class=MsoBodyText style='text-align:justify'><i><u><span lang=IT>per le merci vendute</span></u></i></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>valore di fattura
                    di vendita maggiorato delle spese di trasporto, assicurazione ed altri
                    eventuali costi inerenti se documentabili (se dovuti e non già inclusi nella
                    fattura stessa).</span></p>

            <p class=MsoBodyText style='text-align:justify'><i><u><span lang=IT>per le merci non ancora
                            fatturate</span></u></i></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>costo di
                    rimpiazzo costituito dal prezzo di acquisto delle materie prime oltre ai costi
                    di lavorazioni parziali effettuate sino al momento dell’evento dannoso ed altri
                    eventuali costi inerenti, da documentare specificatamente.</span></p>

            <p class=MsoBodyText style='text-align:justify'><i><u><span lang=IT>per le merci usate che non siano oggetto
                            di un acquisto
                            o di una vendita</span></u></i></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>valore commerciale delle merci al momento del
                    sinistro</span><span lang=IT>.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Nel caso di merci
                    vendute, l’utile sperato sarà corrisposto, incluso nel prezzo di vendita,
                    esclusivamente all’avente diritto ed è indennizzabile nell’ambito del valore
                    fatturato e non come voce di danno separata.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 11<span>      </span>DIRITTO DI
                        ISPEZIONE</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La Compagnia avrà
                    facoltà di ispezionare, in qualsiasi momento negli orari di ufficio, tutta la
                    documentazione riguardante i trasporti e le merci oggetto dell’assicurazione
                    unitamente a qualsiasi altro documento ufficiale del Contraente e
                    dell’Assicurato che abbia attinenza con gli stessi quali i Registri degli
                    acquisti, i Registri delle fatture emesse, la dichiarazione annuale dell’I.V.A.
                    sui quali il Contraente e il singolo Assicurato dovrà fornire i chiarimenti del
                    caso.</span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 12<span>      </span>OPERAZIONI DI
                        CARICO E SCARICO</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La garanzia si
                    intende inoltre estesa ai rischi derivanti dalle operazioni di carico e scarico
                    delle merci assicurate purché dette operazioni siano effettuate con mezzi
                    meccanici idonei ed a cura del vettore incaricato del trasporto o di altri
                    terzi che ne assumano le relative responsabilità.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Si precisa che
                    per “carico” si intende unicamente l’operazione di sollevamento delle merci da
                    terra in prossimità del mezzo di trasporto e per “scarico” l’operazione
                    inversa. </span><span lang=IT style='color:windowtext'>Ogni altra operazione
                    preliminare al trasporto meccanico o manuale delle merci dal luogo di normale
                    giacenza al mezzo di trasporto o successiva è esplicitamente esclusa dalla
                    garanzia.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 13<span>      </span>DURATA DELLA
                        COPERTURA ASSICURATIVA</span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>La copertura assicurativa
                    avrà effetto dal momento in cui i beni
                    vengono ritirati da o sono consegnati a un Vettore designato, secondo quanto
                    specificato dalle informazioni sul <i>tracking
                    </i>della spedizione ricevute dal Vettore Designato. La copertura continuerà ad
                    avere efficacia mentre i beni sono in transito e sino al momento in cui avviene
                    la consegna al destinatario ma, in ogni caso, non oltre quattordici (14) giorni
                    dal momento in cui è avvenuta la spedizione.</span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>La consegna si considera
                    eseguita nel momento in cui avviene la firma
                    per ricevuta della spedizione o nel momento in cui la stessa è consegnata a
                    destinazione, se l’Assicurato o il destinatario ha dato istruzioni che la merce
                    sia consegnata senza necessità che venga apposta la firma per ricevuta. In
                    entrambi i casi, per determinare il momento di consegna rilevano le
                    informazioni di <i>tracking </i>del Vettore
                    designato.</span><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>Nel caso la
                    spedizione sia restituita
                    al mittente a causa del rifiuto o dell’impossibilità del destinatario di
                    accettare la consegna, la copertura si estende sino al momento in cui la merce
                    viene riconsegnata, ma comunque non oltre trenta (30) giorni dalla data in cui
                    i beni sono stati ritirati dal vettore. In entrambi i casi, fanno fede le </span><span
                    lang=IT>informazioni di <i>tracking </i>del
                    Vettore designato.</span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT></span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif'>Le spedizioni
                    firmate per accettazione da un soggetto che appaia avere titolo a ricevere i
                    beni (quali, a titolo di esempio: <i>concierge</i>,
                    portiere, addetto alla reception, altro soggetto residente al medesimo
                    indirizzo, soggetto addetto alla vigilanza) ed effettuate presso l’indirizzo di
                    destinazione si considerano come eseguite. La copertura può essere annullata
                    nel corso della spedizione, qualora l’Assicurato, il mittente, o il
                    destinatario non cooperino o non facciano tutto ciò che è ragionevole
                    attendersi al fine di facilitare o accettare la consegna; in tal caso, è onere
                    dell’Assicurato dimostrare che la perdita è avvenuta nel corso del periodo di
                    copertura. </span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 14<span>      </span>MODALITA’ E
                        REQUISITI AFFINCHE’ LA
                        SPEDIZIONE POSSA ESSERE ASSICURATA</span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>Affinché i beni spediti
                    possano essere coperti dalla presente Polizza</span><span lang=IT>, l’Assicurato
                    dovrà seguire scrupolosamente le seguenti prescrizioni:<span>  </span></span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT></span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(a)<span>           </span>Avviso
                        al destinatario:</span></b><span lang=IT style='font-size:9.0pt;font-family:
            "Arial",sans-serif'> l’Assicurato deve avvisare il destinatario della
                    spedizione e del suo contenuto prima della consegna e dell’obbligo del
                    destinatario di dare pronta notizia in caso di mancata consegna dei beni,
                    nonché dell’obbligo del destinatario di esaminare attentamente i beni al
                    momento della consegna in presenza del personale del vettore e di rilevare, per
                    iscritto e nei confronti del personale del vettore, ogni evidenza di danno,
                    perdita, manomissione, effrazione del pacchetto spedito. In caso di
                    inadempimento a tale obbligo da parte del destinatario, la presente Polizza non
                    offrirà alcuna copertura. <b></b></span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(b)<span>           </span>Doppio
                        imballaggio: </span></b><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif'>salvo
                    diversa autorizzazione per iscritto da parte della Compagnia o dell’Assicurato,
                    tutti i pacchetti devono essere imballati all’interno di due diverse scatole
                    nuove. La scatola più interna conterrà il numero di <i>tracking</i> e non dovrà essere una
                    confezione di gioielleria che
                    permetta di identificare facilmente il contenuto e/o di essere scartata
                    facilmente. Le buste e le confezioni non possono essere assicurate ai sensi di
                    questa Polizza.<span>  </span></span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(c)<span>           </span>Imballaggio
                        e consegna al Vettore: </span></b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>tutti i pacchetti devono essere correttamente
                    imballati e sigillati in modo da resistere al trasporto. Salvo diversa
                    autorizzazione per iscritto da parte della Compagnia o del Contraente, i
                    pacchetti devono essere raccolti presso il mittente, consegnati al personale
                    del Vettore designato, o portati presso lo stesso entro 48 ore dal momento in
                    cui la spedizione è stata comunicata a e confermata/accettata dal Contraente.
                    L’Assicurato deve ottenere una ricevuta per ogni pacchetto lasciato presso un
                    punto di vendita al dettaglio che sia stato previamente autorizzato per
                    iscritto da parte della Compagnia o del Contraente. L’Assicurato non deve mai
                    lasciare i beni in luogo di deposito incustodito o in qualsiasi luogo che non
                    sia presidiato da personale impiegato dal Vettore designato. </span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(d)<span>           </span>Dichiarazione
                        del valore assicurato alla Contraente: </span></b><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif'>le spedizioni di cui
                    l’Assicurato non abbia dichiarato il valore alla Contraente non saranno
                    assicurate dalla presente Polizza.<b></b></span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(e)<span>           </span>Obbligo
                        di non rivelare il contenuto della spedizione: </span></b><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif'>a pena di inefficacia
                    della Polizza, non devono essere inserite nella lettera di vettura,
                    sull'etichetta o sull'esterno del pacco, indicazioni circa l’alto valore del
                    contenuto del pacchetto. A titolo di esempio, l’Assicurato non deve mai fare
                    riferimento a marchi o case d’aste o utilizzare termini che indicano metalli
                    preziosi, pietre preziose o altri beni di valore, quali “gioielli”, “orologi”,
                    “diamanti”, “perle”, “oro”, “argento”, “gemma”, “moneta” o abbreviazioni da cui
                    si comprenda il contenuto del pacchetto sia nel materiale di imballaggio o sui
                    nomi o indirizzi del mittente o del destinatario sulla parte esterna del pacco.
                    Se l’Assicurato ritenesse di dover inserire una qualsiasi di queste parole
                    nella lettera di vettura, sull'etichetta o sull'esterno del pacco, anche in forza
                    di qualsiasi previsione normativa o regolamentare, dovrà richiedere il
                    preventivo consenso scritto del Contraente; in caso contrario, la spedizione
                    non sarà assicurata dalla presente Polizza</span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(f)<span>            </span>Divieto
                        di dichiarare il valore al vettore: </span></b><span lang=IT style='font-size:
            9.0pt;font-family:"Arial",sans-serif'>salvo diversa autorizzazione per iscritto
                    da parte della Compagnia o del Contraente, l’Assicurato non deve mai dichiarare
                    al Vettore designato o ad altro soggetto (eccetto il Contraente) il valore dei
                    beni ai fini delle limitazioni di responsabilità del vettore medesimo o a ogni
                    altro fine. In caso contrario, la presente Assicurazione sarà inefficace.</span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(g)<span>           </span>Trasporto
                        specializzato sicuro:</span></b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'> la Compagnia o il Contraente possono a loro
                    discrezione richiedere che il ritiro avvenga tramite un servizio di trasporto
                    specializzato. La Compagnia e il Contraente si riservano il diritto di
                    richiedere che il ritiro venga svolto tramite un autoveicolo blindato di società
                    specializzata nel settore o di altra società scelta dalla Compagnia o dal
                    Contraente. Previsioni di maggiore dettaglio riguardanti tale tipo di trasporto
                    e i relativi protocolli, ove applicabili, saranno inserite in apposito addendum
                    al <i>Rate sheet </i>del singolo Assicurato.
                    Richiedendo i servizi di trasporto di pacchetti ritirati presso gli appositi
                    punti di ritiro indicati nell’addendum, l’Assicurato da atto e accetta che le
                    previsioni inserite nell’addendum siano applichino in aggiunta al testo di
                    Polizza. I pacchetti ritirati dai punti di ritiro elencati nell’addendum
                    saranno trasportati presso il deposito del Vettore designato esclusivamente da
                    automezzi blindati o tramite altra società scelta dalla Compagnia o dalla
                    Contraente per il trasporto sicuro. Se i pacchetti dell’assicurato non vengono
                    ritirati dai punti di ritiro da un automezzo blindato o tramite altra società
                    scelta dalla Compagnia o dalla Contraente o se i requisiti e protocolli
                    inseriti nell’addendum siano violati o non vengano rispettati in qualunque
                    modo, tali pacchetti non saranno coperti dalla presente Polizza. La Compagnia e
                    il Contraente potrebbero richiedere nell’addendum che l’Assicurato dichiari il
                    valore del pacchetto ai terzi che svolgono il presente servizio di trasporto
                    sicuro.</span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(h)<span>           </span>Report
                        di spedizione: </span></b><span lang=IT style='font-size:9.0pt;font-family:
            "Arial",sans-serif'>salvo diversamente autorizzato dalla Compagnia o dal
                    Contraente per iscritto, l’Assicurato non deve mai consegnare al vettore,
                    insieme al pacchetto spedito, anche il report giornaliero di spedizione e/o
                    l’indicazione dei valori spediti; tali indicazioni devono rimanere ai fini
                    interni dell’Assicurato e devono essere trattate in via riservata
                    dall’Assicurato. Quando l’Assicurato spedisce la merce tramite gli strumenti
                    on-line predisposti dal Contraente (website, mobile apps, API), in tutti i casi
                    in cui viene generata una ricevuta di spedizione di merci di alto valore e
                    viene formulata l’offerta al vettore, il mittente deve assicurarsi che tale
                    ricevuta sia presentata al e riconosciuta dal vettore.</span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify'><b><span lang=IT style='font-size:9.0pt;
            font-family:"Arial",sans-serif'>(i)<span>            </span>Completezza
                        e adeguatezza delle informazioni fornite:</span></b><span lang=IT
                    style='font-size:9.0pt;font-family:"Arial",sans-serif'> l’Assicurato deve
                    fornire informazioni e documentazione accurate e complete, e che siano
                    determinanti e attendibili per la Compagnia e il Contraente per lo svolgimento
                    dei servizi forniti. Tale obbligo di fornire informazioni accurate si applica
                    sia prima di ottenere la copertura sia nel momento in cui viene fatta una
                    richiesta di indennizzo. Qualsiasi omissione o reticenza intenzionale o
                    gravemente colposa nel fornire informazioni o la documentazione prima o al
                    momento della stipula della Polizza, darà diritto alla Compagnia di annullare
                    la copertura (senza diritto alla restituzione del Premio) ai sensi dell’art.
                    1892 c.c.<span>  </span>Negli altri casi in cui le
                    informazioni o la documentazione fornita prima di ottenere la copertura non
                    siano accurate ed esaustive, ma l’omissione o la reticenza non è intenzionale
                    né è dovuta a colpa grave, la Compagnia può recedere dalla Polizza o ridurre la
                    copertura ai sensi dell’art. 1893 c.c. </span></p>

            <p class=MsoNormal style='margin-bottom:6.0pt;text-align:justify;'><b><span lang=IT style='font-size:
            9.0pt;font-family:"Arial",sans-serif'>(j) <span>           </span>Conservazione
                        del pacchetto: </span></b><span lang=IT style='font-size:9.0pt;font-family:
            "Arial",sans-serif'>la richiesta di indennizzo non sarà valida a meno che il
                    pacchetto, il contenitore interno, l’imballaggio e i contenuti siano stati
                    conservati intatti sino al momento dell’ispezione della Compagnia o del
                    Contraente.</span><span lang=IT> </span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 15<span>      </span>MANCATA
                        EFFETTUAZIONE DEL VIAGGIO</span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>La Compagnia non risponde,
                    in nessun caso, di qualsiasi perdita di
                    merce assicurata, danno avvenuto o spesa sostenuta in relazione a tale merce, a
                    seguito di mancata effettuazione del viaggio previsto o dall’impedimento o cambiamento
                    del medesimo dovuti ad arresti, interdizioni, disposizioni restrittive ed atti
                    qualsiasi di Governi, Autorità o popoli.</span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 16 ULTERIORI RAGIONI
                        DI
                        ESCLUSIONE DELLA COPERTURA ASSICURATIVA</span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>La Compagnia non pagherà, in
                    nessun caso, alcun indennizzo per perdita,
                    danno avvenuto o spesa sostenuta in relazione a beni assicurati in conseguenza
                    di:</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>imballaggio o sigillo inadeguato o insufficiente a
                    resistere alle
                    normali avversità che caratterizzano il trasporto in questione o del fatto che
                    l’Assicurato non abbia seguito le istruzioni di imballaggio, etichettatura e/o
                    in merito alle dichiarazioni di valore da fare nei confronti del vettore, a
                    prescindere che l’Assicurato abbia agito in maniera negligente. Fermo quanto
                    sopra, in caso di richiesta di indennizzo per perdite materiali o danni che si
                    presumano essere stati causati da insufficiente o inadeguato imballaggio o
                    preparazione dei beni dell’Assicurato, la Compagnia rinuncerà alla presente
                    eccezione di copertura in ogni caso in cui l’imballaggio o la preparazione del
                    pacchetto non sono stati eseguiti dall’Assicurato, dal mittente o dal
                    destinatario della spedizione, nella misura in cui l’insufficienza o
                    l’inadeguatezza dell’imballaggio era sconosciuto all’Assicurato, al mittente o
                    al destinatario. In tal caso, la Compagnia conserva l’azione di rivalsa nei
                    confronti della parte terza responsabile dell’insufficiente o inadeguato
                    imballaggio dei beni assicurati;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>qualsiasi spedizione in cui non venga richiesta la
                    firma per accettazione
                    o che comunque sia soggetta a clausole, accordi e intese con il vettore in
                    forza dei quali il vettore è autorizzato a consegnare i beni assicurati senza
                    richiedere la firma per accettazione al momento della consegna. La copertura di
                    cui alla presente Polizza è esclusa se il destinatario consente al vettore di
                    effettuare la consegna senza richiedere la firma per accettazione. Salvo il
                    caso in cui la consegna senza firma per accettazione sia avvenuta contro le
                    istruzioni dell’Assicurato, a sua insaputa e per colpa del solo vettore, è
                    escluso l’indennizzo nel caso in cui la spedizione di cui non sia stata
                    richiesta la firma per accettazione risulti consegnata sulla base delle
                    informazioni di <i>tracking </i>del vettore.</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;'><span lang=IT>La
                    Compagnia rinuncerà alla presente difesa in ogni caso in cui il
                    vettore abbia consegnato i beni assicurati senza ottenere la firma per accettazione
                    contro le istruzioni ricevute per iscritto dall’Assicurato e senza che lo
                    stesso ne fosse a conoscenza;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>qualunque spedizione non direttamente consegnata al
                    personale del
                    Vettore Designato entro 48 ore dal momento in cui è sta comunicata la
                    spedizione al Contraente e questi abbia accettato/confermato la copertura, nonché
                    qualunque spedizione che sia consegnata a soggetti diversi dal personale del
                    Vettore designato, incluse (a titolo di esempio) le spedizioni consegnate a un
                    qualunque intermediario, o depositate presso punti di consegna non presidiati
                    e/o presso punti di ritiro o consegna in cui non siano presenti i dipendenti
                    del vettore, eccetto che ciò non sia autorizzato dal Contraente;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>qualsiasi alterazione meccanica e/o elettronica della
                    merce usata o di
                    merce nuova non sigillata;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>qualsiasi rottura di oggetti fragili e delicati come
                    orologi o
                    bicchieri;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>qualsiasi informazione falsa e/o erronea fornita
                    dall’Assicurato e/o
                    dal mittente e/o dal destinatario, incluse, ma senza limitazione, le informazioni
                    errate in merito all’indirizzo di consegna, a prescindere che l’Assicurato
                    abbia osservato il normale standard di diligenza nel fornire tali informazioni;
                    la Compagnia rinuncerà alla presente eccezione di copertura nel caso in cui l’errore
                    o l’omissione sia addebitabile a un soggetto terzo che non richiede alcun
                    indennizzo ai sensi di questa Polizza e, inoltre, il soggetto che riceva un
                    indennizzo ai sensi di Polizza non abbia colposamente commesso l’errore o
                    l’omissione e non abbia avuto conoscenza di ciò. In tal caso, la Compagnia
                    conserva l’azione di rivalsa nei confronti del terzo che abbia commesso
                    l’errore;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(g)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>qualsiasi spedizione che non presenti prove fisiche
                    di manomissione del
                    pacco spedito o chiare prove di penetrazione o manomissione del pacco spedito;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(h)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>qualsiasi spedizione per la quale non sia stata fatta
                    eccezione per
                    iscritto nei confronti del vettore al momento della consegna in merito a
                    evidenza fisica (riconoscibile o visibile) di un danno esterno, di una perdita,
                    di una manomissione del pacco spedito o di una chiara prova di penetrazione o
                    manomissione; ai fini della presente esclusione, la consegna accettata come
                    &quot;soggetta a ispezione”&nbsp;o con dicitura simile non costituisce la
                    contestazione scritta di cui al periodo precedente. La presente esclusione non
                    si applica a danni o perdite occulte qualora il pacco non presenti alcuna prova
                    di un potenziale danno al momento della consegna;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(i)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>di spedizioni inviate&nbsp;in frode&nbsp;al cliente o
                    finalizzate a
                    porre in essere una frode a danno del cliente, del mittente e/o del
                    destinatario (compresi, a titolo esemplificativo, ordini di prodotti effettuati
                    da impostori);</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(j)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>spedizioni dirottate, fermate durante il transito o
                    recuperate in un
                    punto diverso rispetto a quello di consegna originariamente previsto effettuate
                    sulla base di istruzioni o dichiarazioni fornite al Vettore designato fornite
                    da un truffatore&nbsp;e/o dovute a modificazione o alterazioni delle etichette
                    del pacco nel corso del trasporto al fine di effettuare una rispedizione fraudolenta;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(k)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>perdita, danneggiamento o violazione di dati
                    elettronici o altri
                    contenuti non tangibili;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(l)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>frode commessa dall’Assicurato, dal mittente o dal
                    destinatario;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(m)<span style='font:7.0pt "Times New Roman"'>&nbsp;
                            </span></span></span></b><span lang=IT>spedizione o commercio illecito o illegale;</span>
            </p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(n)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>qualsiasi spedizione non comunicata al e non
                    confermata/accettata dal
                    Contraente, secondo quanto previsto dall’Art. 1;</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(o)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>ogni danno conseguenziale o indiretto, come la
                    perdita di profitto, la
                    svalutazione, o la diminuzione del valore come risultato della riparazione del
                    bene. In caso di perdita o danni di beni accoppiati o inclusi in un <i>set </i>di beni, l’indennizzo
                    sarà limitato
                    esclusivamente al bene effettivamente perduto o danneggiato; </span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(p)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>sequestro dei beni assicurati, anche ad opera di
                    autorità doganali; </span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(q)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>rinuncia alla spedizione anche implicita
                    dell’Assicurato, del mittente
                    o del destinatario (ad esempio, per non aver presentato documenti doganali
                    richiesti o non aver organizzato il trasporto alla destinazione finale); e</span></p>

            <p class=MsoBodyText style='margin-left:.5in;text-align:justify;text-indent:
            -.25in;'><b><span lang=IT><span>(r)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
                            </span></span></span></b><span lang=IT>perdita o furto di merci, quando il mittente ha
                    mostrato, comunicato o
                    reso noto in altro modo al vettore il contenuto di una spedizione che include
                    articoli di valore elevato, tra cui, a titolo esemplificativo e non esaustivo,
                    gioielli, opere d'arte, oggetti d'antiquariato, oggetti da collezione, prodotti
                    elettronici o altri oggetti di valore monetario significativo.</span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 17 TERMINI PER LA
                        DENUNCIA DEL SINISTRO</span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>L’Assicurato deve, a pena di
                    decadenza dal diritto all’indennizzo, dare
                    notizia al Contraente del sinistro nei termini elencati qui di seguito. In
                    mancanza, nessuna copertura verrà fornita per tale sinistro: </span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>(i) Termine per la denuncia
                    di un possibile sinistro: l’Assicurato deve
                    dare notizia per iscritto al Contraente immediatamente (ovvero non appena
                    ragionevolmente possibile) al verificarsi della prima delle seguenti
                    circostanze: (a) l’Assicurato è venuto a conoscenza del mancato rispetto della data
                    o orario di consegna garantiti dal vettore che effettua la consegna, </span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>(b) l’Assicurato ha
                    denunciato al vettore che effettua la consegna la
                    ritardata consegna di una spedizione; o </span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>(c) l’Assicurato è venuto a
                    conoscenza di una perdita o di un danno ai
                    beni assicurati.</span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>(ii) Termine per la
                    presentazione della richiesta di indennizzo:
                    l’Assicurato deve presentare per iscritto una richiesta di indennizzo al
                    Contraente o alla Compagnia nei quattordici (14) giorni successivi al
                    verificarsi del primo dei seguenti eventi: </span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>(a) l’Assicurato ha ricevuto
                    la notifica della conclusione di
                    un'indagine da parte del vettore o del Contraente in relazione alla spedizione;
                    o</span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>(b) sono decorsi trenta (30)
                    giorni dal momento in cui la copertura
                    assicurativa è divenuta efficace ai sensi dell’art. 13 della presente Polizza (vale
                    a dire dal momento in cui i beni sono stati ritirati da o sono stati consegnati
                    a un Vettore designato, come risulta dalle informazioni sul tracking della
                    spedizione del Vettore designato) o sono decorsi quarantacinque (45) giorni nel
                    caso in cui il destinatario abbia rifiutato la consegna e la spedizione
                    rifiutata sia stata restituita al mittente.</span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>(iii) Termine per la
                    presentazione della documentazione a sostegno
                    della richiesta di indennizzo: l’Assicurato deve presentare la documentazione a
                    sostegno della sua richiesta di indennizzo (compresa la documentazione relativa
                    agli eventuali danni e a dimostrazione del valore della spedizione) per
                    iscritto al Contraente o alla Compagnia entro quattordici (14) giorni dal
                    momento in cui ha presentato la richiesta di indennizzo. Se a quella data è
                    ancora in corso un'indagine di polizia relativa alla spedizione, il termine è
                    prorogato fino a 14 giorni successivi alla data in cui l’Assicurato è venuto a
                    conoscenza della conclusione dell'indagine di polizia.</span></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 18 <span>     </span>DANNI ALLE
                        CONFEZIONI</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>In caso di danno,
                    risarcibile a termini di polizza, ad etichette, capsule, scatole, astucci,
                    involucri od altro materiale costituente la confezione della merce Assicurato
                    senza che vi sia stato danno al prodotto, la Compagnia si impegna a rimborsare
                    esclusivamente l'ammontare relativo al costo del nuovo confezionamento con il
                    limite massimo del valore assicurato.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>Art. 19<span>   </span>RISCHI
                        CONTINGENTI</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><i><u><span lang=IT>a)<span>  </span>Merci
                                vendute</span></u><span lang=IT></span></i></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La presente Polizza
                    copre alle condizioni previste in questa Polizza anche le spedi­zioni di merce
                    che l’Assicurato vende con termini di resa per i quali l'onere della copertura
                    assicurativa non risulti a suo carico, totalmente o parzialmente (EXW, FCA,
                    FAS, FOB, CFR e simili). Pertanto i danni risarcibili saranno pagabili
                    esclusivamente all’Assicurato solo ed in quanto il destinatario della merce
                    ometta il pagamento delle merci in quanto danneggiate o andate perdute a
                    seguito di un rischio assicurato.</span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT style='color:windowtext'>In caso di danno
                        su merci
                        vendute alle condizioni sopra indicate, l’Assicurato intraprenderà tutte le
                        azioni affinché le merci vengano accettate dai destinatari con pagamento
                        integrale del prezzo di fattura.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Solo nel caso che
                    l’Assicurato non ottenga il pagamento del prezzo di vendita delle merci e ne
                    dia valida dimostrazione alla Compagnia, la stessa risarcirà il danno
                    effettivamente subito nei termini della presente Polizza.</span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT style='color:windowtext'>L’Assicurato si
                        impegna a
                        proseguire in proprio nome, ma a spese della Compagnia, le attività necessarie
                        per il recupero del danno nei confronti dei destinatari ed ogni recupero
                        eventualmente ottenuto sarà di spettanza della Compagnia sino al raggiungimento
                        dell'importo da essa pagata.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La Compagnia
                    pagherà l’indennizzo dovuto in base alla presente clausola non prima di 120
                    giorni dalla data del mancato pagamento e trascorsi ulteriori 60 giorni dal
                    ricevimento della documentazione completa giustificativa del reclamo.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><b><i><u><span lang=IT>b)<span>  </span>Merci
                                Acquistate</span></u><span lang=IT></span></i></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La presente Polizza copre altresì le
                    spedizioni di merce che l’Assicurato
                    compra con termini di resa per i quali l’onere di provvedere alla copertura
                    assicurativa spetta al fornitore.</span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT style='color:windowtext'>In caso di danno
                        su merci
                        acquistate con tale modalità di consegna, l’Assicurato intraprenderà tutte le
                        azioni necessarie affinché la perdita o il danno venga liquidato dalla compagnia
                        di assicurazioni scelta dal fornitore e/o dal fornitore stesso.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Qualora tali
                    azioni risultino inefficaci in tutto o in parte, la presente Polizza garantisce
                    il rimborso del danno sofferto dall’Assicurato, nei limiti e alle condizioni
                    previste da questa Polizza.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>La presente Polizza
                    inoltre, a prescindere dall’inottemperanza degli obblighi di assicurazione, garantisce
                    per “differenza di condizioni” anche quei rischi eventualmente non coperti
                    dalle polizze stipulate dai fornitori e/o per loro conto, nel qual caso
                    troveranno applicazione i termini e le condizioni di questa polizza.</span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT style='color:windowtext'>Nei casi previsti
                        nei paragrafi
                        precedenti, l’Assicurato si impegna a restituire immediatamente alla Compagnia le
                        somme eventualmente recuperate in connessione ai danni e alle perdite subiti
                        dalle merci acquistate in qualunque epoca successiva al pagamento
                        dell’indennizzo da parte della Compagnia.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><b><u><span lang=IT>Importante</span></u><span
                        lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>È condizione essenziale per l’operatività
                        di questa
                        garanzia dei Rischi Contingenti che l’esistenza della stessa non sia portata a
                        conoscenza dei clienti, ricevitori e/o sub-fornitori dell’Assicurato per nessun
                        motivo.</span></b></p>

            <p class=MsoNormal style='text-align:justify;'><b><span lang=IT style='font-size:9.0pt;
            ;font-family:"Arial",sans-serif;'>I diritti derivanti dalla presente clausola non sono in
                        alcun caso cedibili a terzi.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 20 <span>     </span>CONSTATAZIONE
                        DANNI E PERDITE</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>L’Assicurato è tenuto a:</span></b></p>

            <p class=MsoBodyText style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-family:"Times New Roman",serif'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><b><span lang=IT>dare disposizioni affinché in caso di sinistro grave
                        (</span></b><b><span lang=IT>vale a dire di un sinistro il cui importo possa essere
                        presumibilmente
                        superiore ad Euro 2,500 al netto dell’eventuale Franchigia</span><span lang=IT>)
                        sia data immediata notizia telefonica o scritta all’intermediario della Compagnia,
                    </span></b><b><span lang=IT>UPS Capital Versicherungsvermittlung
                        GmbH -<span>  </span></span></b><b><span lang=IT>telefono: +49 (0) 69 6630 8330, telefax: +49
                        (0) 2131 – 154 8535,
                        e-mail: </span></b><span lang=IT><a
                        href="mailto:risksolutionsit@ups.com"><b><span>risksolutionsit&#64;ups.com</span></b></a></span><b><span lang=IT>onde lo stesso possa
                        disporre per l'intervento del proprio Commissario di Avaria sul luogo del
                        sinistro;</span></b></p>

            <p class=MsoBodyText style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-family:"Times New Roman",serif'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><b><span lang=IT>prendere i provvedimenti necessari per evitare o diminuire
                        la perdita o
                        il danno;</span></b></p>

            <p class=MsoBodyText style='margin-left:.25in;text-align:justify;text-indent:
            -.25in;'><span lang=IT style='font-family:"Times New Roman",serif'><span>-<span
                            style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span></span></span><b><span lang=IT>non apportare, se non per il salvataggio della merce o per
                        giustificati
                        motivi, alcuna modifica allo stato del veicolo e del carico prima
                        dell’intervento del Commissario d’Avaria o del perito designato dalla Compagnia
                        o dal suo intermediario.</span></b></p>

            <p class=MsoBodyText style='margin-left:.25in;text-align:justify'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>L’Assicurato ha il diritto di presentare la
                        richiesta di
                        indennizzo alla Compagnia o al Contraente. La Compagnia effettuerà qualsiasi
                        pagamento nei confronti dell’Assicurato tramite il Contraente. Salvo richiesta
                        del Contraente, la Compagnia non farà alcun pagamento diretto in favore
                        dell’Assicurato. </span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>L’Assicurato dovrà, inoltre, espletare
                        tutti gli atti
                        necessari per la definizione del danno, la tutela e la salvaguardia dei diritti
                        della Compagnia, permettere la rilevazione e l’ispezione delle merci danneggiate,
                        nonché dei materiali di imballaggio all’interno dei quali le merci sono state
                        spedite, mettere a disposizione tutti i documenti a prova dell'esistenza,
                        genere e valore delle merci assicurate, nonché salvaguardare i diritti di
                        rivalsa nei confronti di ogni eventuale responsabile. Nel richiedere
                        l’indennizzo, l’Assicurato garantisce di essere il solo titolare all’indennizzo
                        assicurativo e di non aver esonerato alcun soggetto terzo da responsabilità per
                        il sinistro (incluso, ma senza limitazione, il Vettore designato).</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>In caso di furto o rapina, l’Assicurato, o
                        chi per esso,
                        dovrà darne immediata denuncia alle Autorità fornendo circostanziata
                        descrizione dei fatti, gli elementi idonei a identificare la merce, le
                        generalità dei soggetti addetti alla consegna, di eventuali accompagnatori e
                        testimoni, nonché l’esistenza e l’eventuale attivazione di apparecchiature
                        antifurto o altri sistemi di protezione e ottenere copia della denuncia. </span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Il pagamento di ogni richiesta di indennizzo
                    non comporta il riconoscimento
                    di alcuna futura richiesta di risarcimento e non pregiudica alcun diritto,
                    rimedio o difesa della Compagnia ai sensi di Polizza. Effettuato il pagamento
                    dell’indennizzo, la Compagnia è automaticamente surrogata nei diritti
                    dell’Assicurato contro terzi responsabili, incluso il Vettore designato. L’Assicurato
                    presterà alla Compagnia e al Contraente </span><span lang=IT>tutta l’assistenza che possano
                    ragionevolmente richiedere</span><span lang=IT>
                    e deve cooperare in caso di azione di surroga da parte della Compagnia e
                    permettere alla Compagnia di perseguire l’azione</span><span lang=IT>
                    surrogatoria nei confronti di terzi per conto dell’Assicurato. Gli eventuali
                    frutti dell’azione surrogatoria spettano alla Compagnia. A seguito di azione
                    surrogatoria contro i terzi responsabili, la Compagnia tratterrà per sé un
                    importo pari all’ammontare dell’indennizzo versato oltre le spese
                    ragionevolmente sostenute in connessione con il sinistro e la successiva azione
                    di surroga. Se l’ammontare recuperato a seguito dell’azione surrogatoria eccede
                    l’indennizzo versato oltre le spese ragionevolmente sostenute in connessione
                    con il sinistro e la successiva azione di surroga, la parte eccedente verrà
                    versata all’Assicurato.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Effettuato il
                    pagamento dell’indennizzo, <a name="_Hlk128762434">su richiesta della
                        Compagnia, l’Assicurato è tenuto a cedere alla Compagnia, per quanto occorre
                        possa e senza pregiudizio rispetto a quanto previsto dall’art. 1916 c.c., i
                        crediti risarcitori nei confronti dei terzi responsabili. </a></span></p>

            <p class=MsoBodyText style='text-align:justify'><span><b><span lang=IT></span></b></span></p>

            <span></span>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 21<span>      </span>FRANCHIGIA
                        PERITALE - </span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>L’Assicurato è
                    dispensato dal richiedere l’intervento del Commissario d’Avaria solo per
                    richieste di risarcimento il cui importo possa essere presumibilmente inferiore
                    a € 2.500 al netto dell’eventuale Franchigia.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Resta in ogni
                    caso inteso che l’Assicurato - sotto la propria responsabilità - dovrà fornire
                    tutta la documentazione necessaria per comprovare il reclamo.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>Art. 22<span>   </span>CHIUSA
                        INCHIESTA</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Qualora a seguito
                    di un sinistro sia avviata dalle competenti Autorità un’inchiesta giudiziaria
                    sui fatti che hanno determinato il sinistro, la Compagnia non si avvarrà della
                    facoltà di rinviare la liquidazione del danno sino alla presentazione del
                    documento di chiusa inchiesta.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT style='color:
            windowtext'>Quanto sopra non potrà tuttavia essere fatto valere nel caso sia
                    fondato ritenere che il sinistro sia stato determinato da dolo dell’Assicurato
                    nonché infedeltà e/o azione dolosa dei dipendenti dell’Assicurato.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>L’Assicurato si
                    impegna comunque a fornire la suddetta documentazione di chiusa inchiesta non
                    appena predisposta dalle Autorità e a restituire alla Compagnia quanto dalla
                    stessa liquidato nel caso in cui dovessero emergere comportamenti dolosi a suo
                    carico.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 23<span>      </span>MERCI FATTURATE
                        IN VALUTA</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Nel caso di danni
                    subiti dalle merci assicurate che risultino vendute/acquistate in valuta
                    estera, gli stessi saranno risarciti in Euro con controvalore da conteggiarsi
                    al giorno dell'emissione della fattura stessa.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>L’assicurazione
                    in valuta estera sarà ammessa a condizione che il pagamento del Premio
                    corrispondente sia effettuato nella stessa valuta.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 24 <span>     </span>RECESSO DAL
                        CONTRATTO<span>     
                        </span></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>E' facoltà della Compagnia di recedere dal
                        rapporto assicurativo
                        con il singolo Assicurato, nonché di quest’ultimo di recedere dalla presente Polizza,
                        in qualsiasi momento dandone preavviso a mezzo lettera raccomandata. </span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 25<span>      </span>RISOLUZIONE DEL
                        CONTRATTO</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>La risoluzione del contratto opera
                        automaticamente senza
                        necessità di comunicazione allo scadere di 48 ore dal momento dello scoppio di
                        guerra anche non dichiarata fra almeno due dei seguenti Paesi: Regno Unito,
                        Stati Uniti d’America, Francia, Federazione Russa (CSI) e Repubblica Popolare
                        Cinese.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>La Compagnia ha comunque il diritto di
                        esigere il
                        versamento dei premi dovuti ma non ancora pagati.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 26<span>      </span>AGGRAVAMENTO DEL
                        RISCHIO - BUONA FEDE</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>L’omissione di
                    dichiarazione da parte del Contraente o dell’Assicurato di una circostanza
                    aggravante il rischio, così come qualsiasi errore e/o omissione e/o ritardata
                    comunicazione non intenzionale od involontaria commessa dagli stessi o dalle
                    persone di cui devono rispondere a norma di legge, nonché amministratori e/o
                    dirigenti non pregiudicheranno questa assicurazione.</span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>Resta inteso che l’Assicurato avrà
                        l’obbligo di
                        corrispondere alla Compagnia il maggior Premio calcolato proporzionalmente
                        rispetto al maggior rischio che ne è derivato, con decorrenza dal momento in
                        cui la circostanza aggravante si è verificata ed anche se nel frattempo il
                        rischio si è concluso.</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><u><span lang=IT>Art. 27<span>   </span>DICHIARAZIONI
                            NON VERITIERE, INESATTE O RETICENTI</span></u></b></p>

            <p class=MsoBodyText style='text-align:justify'><b><u><span lang=IT></span></u></b></p>

            <p class=p2 style='text-align:justify'><b><u><span lang=IT style='font-size:9.0pt'>L</span><span lang=IT>e
                            dichiarazioni non
                            veritiere, inesatte o reticenti rese dal soggetto legittimato a fornire le
                            informazioni richieste per la conclusione del contratto possono compromettere
                            il diritto alla prestazione<span class=apple-converted-space>&nbsp;ai sensi
                                degli Artt. 1892 e 1893 c.c.</span></span></u></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 28<span>      </span>LEGGE
                        APPLICABILE</span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT>Il presente
                    contratto e tutti i suoi allegati sono regolati dalla legge italiana e
                    assoggettati alla giurisdizione italiana.</span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT style='font-size:
            11.0pt;'></span></p>

            <p class=MsoBodyText style='text-align:justify;'><b><span lang=IT>Art. 29<span>      </span>DURATA DEL
                        CONTRATTO – TACITO RINNOVO</span></b></p>

            <p class=MsoBodyText style='text-align:justify;'><span lang=IT>La
                    presente Polizza è stipulata con effetto dalle ore 24.00 dell’[xx] alle ore 24.00
                    del [xx] per un periodo di 365 giorni (o di 366 in caso di anno bisestile).</span></p>

            <p class=MsoBodyText style='text-align:justify'><b><span lang=IT>Essa si intenderà tacitamente rinnovata per
                        un ulteriore periodo
                        di 365 giorni </span></b><span lang=IT>(o di 366 in caso di anno bisestile),<b> contro pagamento
                        del Premio come
                        precedentemente indicato salvo disdetta da parte della Compagnia o del
                        Contraente secondo quanto previsto dalle presenti Condizioni Particolari.</b></span><span
                    lang=IT style='font-size:11.0pt;'></span></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT style='font-size:
            11.0pt;'></span></p>

            <p class=MsoNormal><b><span lang=IT style='font-size:9.0pt;font-family:"Arial",sans-serif;'></span></b></p>

            <p class=MsoBodyText style='text-align:justify'><span lang=IT style='font-family:
            "Times New Roman",serif'></span></p>

        </div>

    </mat-dialog-content>
</div>